import { AvailabilitiesResponse } from "@/types/responses";

export const getAvailablePackagesWiyp = (availResponse: AvailabilitiesResponse) => {
    const availablePackageCodeWiyp: { liheId: string, codePackage: string, prestId: string, maxPromo: number, skipass: number | undefined }[] = []
    availResponse.availablePackages!.forEach(availablePackage => {
        availablePackageCodeWiyp.push({ liheId: availablePackage.liheId!, codePackage: availablePackage.codePackage!, prestId: availablePackage.prestId! as string, maxPromo: 0, skipass: availablePackage.skipass ?? undefined })
    });
    availResponse.prestations!.forEach(prestation => {
        availablePackageCodeWiyp.push({ liheId: prestation.liheId!, codePackage: prestation.codePackage!, prestId: prestation.prestId!, maxPromo: 0, skipass: prestation.skipass ?? undefined })
    });
    // Ensure only unique codePackage/prestId combinations
    const uniqueMap = new Map();
    for (const entry of availablePackageCodeWiyp) {
        const key = `${entry.codePackage}-${entry.prestId}`;
        if (!uniqueMap.has(key)) {
            uniqueMap.set(key, entry);
        }
    }
    return Array.from(uniqueMap.values())
}